module.exports = __webpack_public_path__ + "static/media/forms.c19d3cf5.svg";